import { store } from '../../store';
import {
  setToken,
  updateCurrentUser,
  logout as logoutAction,
} from '../../store/slices/authSlice';
import { mockUsers } from '../mockData';

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

function storeSession(user, token) {
  store.dispatch(
    setToken({
      token,
      refreshToken: 'mock-refresh-' + Date.now(),
      expiresAt: Date.now() + 60 * 60 * 1000,
    })
  );
  store.dispatch(
    updateCurrentUser({
      sub: user.id,
      given_name: user.firstName,
      family_name: user.lastName,
      email: user.email,
      role: user.role,
    })
  );
}

export const mockAuthService = {
  async login(email, password) {
    await delay(400);

    const user = mockUsers.find((u) => u.email === email && u.password === password);

    if (!user) {
      throw new Error('Invalid email or password');
    }

    const { password: _password, ...userWithoutPassword } = user;
    const token = 'mock-jwt-token-' + Date.now();
    storeSession(userWithoutPassword, token);

    return {
      success: true,
      user: userWithoutPassword,
      token,
    };
  },

  async loginWithGoogle() {
    await delay(400);
    const googleUser = mockUsers.find((u) => u.loginType === 'Federated' || u.loginType === 'Both');
    if (!googleUser) throw new Error('No Google account linked');
    const { password: _password, ...userWithoutPassword } = googleUser;
    const token = 'mock-jwt-token-google-' + Date.now();
    storeSession(userWithoutPassword, token);
    return { success: true, user: userWithoutPassword, token };
  },

  async loginWithMicrosoft() {
    await delay(400);
    const msUser = mockUsers.find((u) => u.loginType === 'Federated' || u.loginType === 'Both');
    if (!msUser) throw new Error('No Microsoft account linked');
    const { password: _password, ...userWithoutPassword } = msUser;
    const token = 'mock-jwt-token-ms-' + Date.now();
    storeSession(userWithoutPassword, token);
    return { success: true, user: userWithoutPassword, token };
  },

  async exchangeExternalLogin() {
    await delay(300);
    const user = mockUsers.find((u) => u.loginType === 'Federated' || u.loginType === 'Both');
    if (!user) throw new Error('No external login session');
    const { password: _password, ...userWithoutPassword } = user;
    const token = 'mock-jwt-token-ext-' + Date.now();
    storeSession(userWithoutPassword, token);
    return { success: true, user: userWithoutPassword, token };
  },

  async exchangeAccountActivation() {
    await delay(300);
    const user = mockUsers[0];
    if (!user) throw new Error('No activation session');
    const { password: _password, ...userWithoutPassword } = user;
    const token = 'mock-jwt-token-activate-' + Date.now();
    storeSession(userWithoutPassword, token);
    return { success: true, user: userWithoutPassword, token };
  },

  async impersonate() {
    throw new Error('Impersonation is not available in mock mode.');
  },

  exitImpersonation() {
    return null;
  },

  isImpersonating() {
    return false;
  },

  logout() {
    store.dispatch(logoutAction());
  },

  getCurrentUser() {
    return store.getState().auth.user || null;
  },

  isAuthenticated() {
    return store.getState().auth.isAuthenticated;
  },

  getToken() {
    return store.getState().auth.token || null;
  },
};
